import { Component, Input } from '@angular/core';
import { IWizardContentComponent } from '../../../wizard.content';

@Component({
  selector: 'radius-results',
  templateUrl: './radius.servers.results.component.html',
  styleUrls: ['./radius.servers.results.component.scss']
})
export class RadiusResultsComponent implements IWizardContentComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() step: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() subStep: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any;

  requestFailed(): boolean {
    return this.wizardCtrl.getWizardService().requestFailed;
  }

  get errorMessage(): string {
    return this.wizardCtrl.getWizardService().errorMessage;
  }
  get successMessage(): string {
    return this.wizardCtrl.getWizardService().successMessage;
  }
}
